import { render } from "./addReplacementQuote.vue?vue&type=template&id=4b42081c"
import script from "./addReplacementQuote.vue?vue&type=script&lang=js"
export * from "./addReplacementQuote.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__